export const galleryItems = [
  {
    title: "Fully loaded container of packed household goods",
    category: "Packing & Moving",
    image:
      "/uploads/gallery-container-loaded.jpeg",
  },
  {
    title: "Garden plants and household items loaded for a move",
    category: "House Shifting",
    image:
      "/uploads/gallery-garden-plants.jpeg",
  },
  {
    title: "Our container truck loaded and ready for delivery",
    category: "Our Fleet",
    image:
      "/uploads/crew-container.jpeg",
  },
  {
    title: "Our shifting crew outside the container truck",
    category: "Our Team",
    image:
      "/uploads/crew-ready.jpeg",
  },
  {
    title: "Our warehouse and operations office in Bangalore",
    category: "Warehouse & Storage",
    image:
      "/uploads/warehouse-office.jpeg",
  },
  {
    title: "Household goods wrapped and staged before loading",
    category: "Packing & Moving",
    image:
      "/uploads/about-house-shifting.jpeg",
  },
  {
    title: "Garden plants and pots loaded for a home move",
    category: "House Shifting",
    image:
      "/uploads/gallery-plants-pots.jpeg",
  },
  {
    title: "Wooden wardrobe multi-layer wrapped for transit",
    category: "Packing & Moving",
    image:
      "/uploads/gallery-wardrobe-wrap.jpeg",
  },
  {
    title: "Furniture and mirrors secured inside the container",
    category: "Our Fleet",
    image:
      "/uploads/gallery-furniture-mirrors.jpeg",
  },
  {
    title: "Bubble-wrapped wardrobe packed inside the home",
    category: "Packing & Moving",
    image:
      "/uploads/service-house-shifting.jpeg",
  },
  {
    title: "Household items loaded and secured inside the container",
    category: "Our Fleet",
    image:
      "/uploads/gallery-goods-secured.jpeg",
  },
  {
    title: "Refrigerator, sofa and goods tied down for transit",
    category: "Our Fleet",
    image:
      "/uploads/about-refrigerator-sofa.jpeg",
  },
  {
    title: "Household goods under protective cover in our warehouse",
    category: "Warehouse & Storage",
    image:
      "/uploads/about-storage.jpeg",
  },
  {
    title: "Furniture and two-wheelers stored safely at our facility",
    category: "Warehouse & Storage",
    image:
      "/uploads/service-storage.jpeg",
  },
  {
    title: "Our branded covered-body Eicher truck on the road",
    category: "Our Fleet",
    image:
      "/uploads/truck-on-road.jpeg",
  },
  {
    title: "Truck loaded with packed household goods outside a home",
    category: "Our Fleet",
    image:
      "/uploads/about-hero-truck.png",
  },
  {
    title: "Household goods packed into labelled crates",
    category: "Packing & Moving",
    image:
      "/uploads/about-office-shifting.jpeg",
  },
  {
    title: "Our fleet of Lahari Eicher trucks ready for dispatch",
    category: "Our Fleet",
    image:
      "/uploads/hero-fleet-banner.jpeg",
  },
  {
    title: "Crew unloading boxes from our branded truck at a customer's home",
    category: "Our Team",
    image:
      "/uploads/hero-home.jpeg",
  },
];

export const galleryCategories = [
  "All",
  "House Shifting",
  "Packing & Moving",
  "Warehouse & Storage",
  "Our Fleet",
  "Our Team",
];